import React from "react";
import { HelpActionContainer, Caption } from "./styles.js";

const Help = () => {
  return (
    <HelpActionContainer>
      <a
        href="https://gcc-punchout.s3.amazonaws.com/Vendor+Portal/Help+Link/GCC-VendorPortal_Help.pdf"
        target=">blank"
      >
        <img src="/images/question_mark.svg" />
        <Caption>Help</Caption>
      </a>
    </HelpActionContainer>
  );
};

export default Help;
